import requestDefault from '@/shared/utils/request';
import type {
  ContractDetailType,
  ContractListType,
  GetContractReadParamType,
  ContractReadParamType,
  GetContrackDetailParamType,
  GetContrackListParamType,
} from '../types';

/**
 * 根据场景查询合同协议列表
 * @param scene 合同场景
 */
export const getContractList = (
  params: GetContrackListParamType,
): Promise<ContractListType[]> => requestDefault.postGate(
  'f.marketing.rights.contract.list',
  { ...params },
  { abortXhr: true },
);

/**
 * 查询合同详情
 * @param templateId 合同模版id
 * @param extraParams 额外参数
 */
export const getContractDetail = (
  params: GetContrackDetailParamType,
): Promise<ContractDetailType> => requestDefault.postGate(
  'f.marketing.rights.contract.detail',
  { ...params },
  { showLoading: undefined, abortXhr: true },
);

/**
 * 查询是否强制阅读
 * @param packageType 卡种
 */
export const queryIsRead = (
  params: GetContractReadParamType,
): Promise<boolean> => requestDefault.postGate(
  'f.marketing.rights.contract.queryIsRead',
  { ...params },
  { showLoading: undefined },
);

/**
 * 保存协议阅读记录
 * @param packageType 卡种
 */
export const contractReadSave = (
  params: ContractReadParamType,
): Promise<ContractDetailType> => requestDefault.postGate(
  'f.marketing.rights.contract.saveRecord',
  { ...params },
  { showLoading: undefined },
);
